import React from "react";
import { useTranslation } from "react-i18next";

export default function Spb(): JSX.Element {
    const { t } = useTranslation("assessment");
    return (
        <>
            <h3>{t("spb.title") as string}</h3>
            <p>{t("spb.paragraph-1-1") as string}<a href={t("spb.hyperlink-1") as string} target='_blank' rel="noopener noreferrer">{t("spb.hyperlink-text-1") as string}</a>{t("spb.paragraph-1-2") as string}</p>
            <p>{t("spb.list-title") as string}</p>
            <ul>
                <li>{t("spb.list.point-1") as string}</li>
                <li>{t("spb.list.point-2") as string}</li>
                <li>{t("spb.list.point-3") as string}</li>
                <li>{t("spb.list.point-4") as string}</li>
                <li>{t("spb.list.point-5") as string}</li>
                <li>{t("spb.list.point-6") as string}</li>
                <li>{t("spb.list.point-7") as string}</li>
                <li>{t("spb.list.point-8") as string}</li>
                <li>{t("spb.list.point-9") as string}</li>
                <li>{t("spb.list.point-10") as string}</li>
                <li>{t("spb.list.point-11") as string}</li>
            </ul>
            <p>{t("spb.paragraph-2") as string}</p>
            <p>{t("spb.paragraph-3") as string}<a className="bolder-text" href={t("spb.hyperlink-2") as string} target='_blank' rel="noopener noreferrer">{t("spb.hyperlink-text-2") as string}</a>.</p>
        </>
    );
}